import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { AuthService } from '../shared/services/auth.service';
import { JsonPipe } from '@angular/common';

import { environment } from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  token: string;
  constructor(private http: HttpClient, private auth: AuthService) {

  }

  public getData() {
    return this.http.get("/assets/data.json");
  }

  /**
   * resizeImage
image, width, height   */
  public resizeImage(image, width, height) {
    var resizedImage;
    var errorMessage;

    const body = {
      image: image,
      width: width,
      height: height,
    }
    this.http.post<any>(`${environment.apiUrl}/image/resize`, body).subscribe({
      next: data => {
        resizedImage = data;
        return resizedImage;
      },
      error: error => {
        errorMessage = error.message;
        console.error('There was an error!', error);
        return errorMessage;
      }
    })

  }

  public generatepdf(image) {
    return this.http.post(`${environment.apiUrl}/pdf`, { image: `${image}` })

  }

  async updateNode(obj) {
    const body = obj
    const token = await this.auth.getToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      }), responseType: 'text' as 'json'
    };

    return this.http.post<any>(`${environment.apiUrl}/node/update`, body, httpOptions).toPromise()
  }

  async getOfficialGedcom() {
    const token = await this.auth.getToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      }), responseType: 'text' as 'json'
    };

    return this.http.get<any>(`${environment.apiUrl}/public/gedcoms`, httpOptions).toPromise()
  }

  async postUserOfficialGedcom(filename: string) {
    const token = await this.auth.getToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    };
    // Maybe change post request to object and change api side??
    let body = { filename: filename }

    return this.http.post(`${environment.apiUrl}/public/gedcom`, body, httpOptions).toPromise()
  }



  async getNodes(gedcomid) {
    const token = await this.auth.getToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    };

    return this.http.get(`${environment.apiUrl}/nodes/${gedcomid}`, httpOptions).toPromise()
  }

  async postFile(fileToUpload: File, fileName) {
    const token = await this.auth.getToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    };
    const formData: FormData = new FormData();
    formData.append('gedcom', fileToUpload, fileName);
    return this.http.post(`${environment.apiUrl}/upload`, formData, httpOptions).toPromise()
  }

  getAuthToken() {
    this.auth.getToken().then((token: string) => {
      this.token = token;
    })
  }

  async getGedcoms() {
    const token = await this.auth.getToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    };
    return this.http.get(`${environment.apiUrl}/gedcom`, httpOptions).toPromise()
  }

  async deleteGedcom(id) {
    const token = await this.auth.getToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    };
    return this.http.delete(`${environment.apiUrl}/gedcom/${id}`, httpOptions).toPromise()
  }

  async getGedcom(id) {
    const token = await this.auth.getToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    };
    return this.http.get(`${environment.apiUrl}/gedcom/${id}`, httpOptions).toPromise()
  }

}